import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { Transition } from 'react-transition-group';

/**
 * SlideDown Component
 * @extends Component
 * @desc SlideDown component Slides the element down over time. The offset prop determines how far the element needs to slide.
 *       The duration prop sets how long the transition should take.
 * @returns {Node} a SlideDown Component
 */
class SlideDown extends PureComponent {

    get defaultStyles() {
        const { offset, duration } = this.props;
        return {
            transition: `all ${duration}ms ease-in-out`,
            marginTop: -offset
        };
    }

    get transitionStyles() {
        const { offset } = this.props;
        return {
            entering: { marginTop: -offset },
            entered: { marginTop: 0 },
            exiting: { marginTop: 0 },
            exited: { marginTop: -offset }
        };
    }

    render = () => {
        const { children, duration, ...props } = this.props;
        return (
            <div style={{ overflow: 'hidden' }}>
                <Transition in appear timeout={duration} {...props}>
                    {(state) => (
                        <div
                            style={{
                                ...this.defaultStyles,
                                ...this.transitionStyles[state]
                            }}
                        >
                            {children}
                        </div>
                    )}
                </Transition>
            </div>
        );
    };

}

SlideDown.propTypes = {
    children: PropTypes.node.isRequired,
    duration: PropTypes.number,
    offset: PropTypes.number.isRequired
};

SlideDown.defaultProps = {
    duration: 500
};

export { SlideDown };
